import type { ReactNode } from "react";
import { Badge } from "@/ui";
import { useT } from "@/app";
import { token } from "@/design/theme";

/**
 * A consistent screen header (title + subtitle + the cloud-only marker + end actions) used across the
 * patient-portal screens. The "Cloud uniquement" badge reminds the operator this surface is central-hosted.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  const { t } = useT();
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: token.s4,
        flexWrap: "wrap",
        marginBlockEnd: token.s5,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: token.s1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: token.s2, flexWrap: "wrap" }}>
          <h1 style={{ fontSize: token.fsH1, margin: 0 }}>{title}</h1>
          <Badge tone="info" glyph="☁">
            {t("pp.cloud.badge")}
          </Badge>
        </div>
        {subtitle && (
          <p style={{ margin: 0, color: token.slate, fontSize: token.fsBody }}>{subtitle}</p>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: token.s2 }}>{actions}</div>}
    </header>
  );
}
